import { defaultFilter } from '@components/Table/table.utils';
import { schema } from '@Schema/schema';
import { withDefaults } from '@Schema/utils';
import { createFileRoute, stripSearchParams } from '@tanstack/react-router';
import { zodValidator } from '@tanstack/zod-adapter';
import { EntityTypeConfigKeys } from '@utils/entityViewConfig';
import { PAGE_PATHS } from '../../../../../../types';

const path = PAGE_PATHS.IDENTITIES;
export const Route = createFileRoute('/_breadcrumbsLayout/$accountId/identities/identities/$id/')({
  staticData: {
    path,
    key: EntityTypeConfigKeys.Identity,
  },
  validateSearch: zodValidator(withDefaults(schema.IDENTITIES, defaultFilter)),
  search: {
    middlewares: [stripSearchParams(defaultFilter)],
  },
});
